export const CompanyData = [
    { name: "Companies List",   link:"/CompanyDashboard/Companies" },
    // { name: "CFO's List",   link:"/CompanyDashboard/Team-Members" },
     { name: "Settings",  link:"/CompanyDashboard/settings" },
    ];